import { RouteEntry } from "../../shared/routes";
import { IdentityRoles } from "../../configure/security/IdentityRoles";
import { ManageHome } from "./ManageHome";

export const manageRoutes: Array<RouteEntry> = [
    { path: '/manage', exact: true, component: ManageHome, authorize: true, requireRole: IdentityRoles.SubscriptionAdministration },
];

